import React, { useEffect, useMemo, useState } from "react";
import styles from "./AdminBills.module.css";

import PageLayout from "../../components/PageLayout/PageLayout";
import BillList from "../../components/MainContent/Body/BillList/BillList";

import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../app/store";

import {
  BillStatus,
  getBills,
  selectBills,
  selectBillsError,
  selectBillsLoading,
} from "../../slices/bill/billSlice";

type BillFilter =
  | "all"
  | "new_offer"
  | "highlight"
  | "recommended"
  | "extend_period";

const AdminBills: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const bills = useSelector(selectBills);
  const loading = useSelector(selectBillsLoading);
  const error = useSelector(selectBillsError);

  const [statusFilter, setStatusFilter] =
    useState<BillStatus | "all">("pending");

  const [typeFilter, setTypeFilter] =
    useState<BillFilter>("all");

  useEffect(() => {
    dispatch(getBills());
  }, [dispatch]);

  const filteredBills = useMemo(() => {
    return bills.filter((bill) => {
      const statusOk =
        statusFilter === "all" ||
        bill.status === statusFilter;

      const typeOk =
        typeFilter === "all" ||
        bill.type === typeFilter;

      return statusOk && typeOk;
    });
  }, [bills, statusFilter, typeFilter]);

  return (
    <PageLayout className={styles.AdminBills}>
      <h1 className={styles.Title}>
        Wszystkie rachunki
      </h1>

      <div className={styles.InfoBox}>
        <div className={styles.InfoTitle}>
          Zarządzanie rachunkami
        </div>

        <div className={styles.InfoText}>
          Przeglądaj wszystkie rachunki użytkowników,
          filtruj je według statusu oraz rodzaju usługi.
        </div>
      </div>

      <div className={styles.Filters}>
        <div className={styles.Filter}>
          <label htmlFor="bill-status-filter">
            Status
          </label>

          <select
            id="bill-status-filter"
            value={statusFilter}
            onChange={(e) =>
              setStatusFilter(
                e.target.value as BillStatus | "all"
              )
            }
          >
            <option value="pending">
              Oczekujące
            </option>

            <option value="paid">
              Opłacone
            </option>

            <option value="cancelled">
              Anulowane
            </option>

            <option value="all">
              Wszystkie
            </option>
          </select>
        </div>

        <div className={styles.Filter}>
          <label htmlFor="bill-type-filter">
            Usługa
          </label>

          <select
            id="bill-type-filter"
            value={typeFilter}
            onChange={(e) =>
              setTypeFilter(
                e.target.value as BillFilter
              )
            }
          >
            <option value="all">
              Wszystkie
            </option>

            <option value="new_offer">
              Nowa publikacja
            </option>

            <option value="extend_period">
              Przedłużenie
            </option>

            <option value="highlight">
              Wyróżnienie
            </option>

            <option value="recommended">
              Polecana firma
            </option>
          </select>
        </div>
      </div>

      {loading && (
        <div className={styles.Message}>
          Pobieranie rachunków...
        </div>
      )}

      {!loading && error && (
        <div className={styles.Error}>
          {error}
        </div>
      )}

      {!loading && !error && (
        <BillList
          bills={filteredBills}
          isAdmin
        />
      )}
    </PageLayout>
  );
};

export default AdminBills;